import { calcColorStatePreAgenda, calcStateTextPreAgenda, cellLineaRazonSocial, emptyCellOneLevel, ESTADO_PREAGENDAMIENTO_PYL, EstadosPreagendamientoEnumChoice, formatDateWithTimeCell } from "@/shared";
import { EstadoComponente } from "@/shared/components/ui";
import { EstadosPreagendamientoCodigoEnum } from "@/shared/interfaces";
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import dayjs from "dayjs";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

export const useTableColumnsPreagendamientoPymes = () => {

  const preagendamientoColumns = useMemo<MRT_ColumnDef<IPreagendamientoPymes>[]>(
    () => [
      {
        accessorKey: 'identificacion',
        header: 'Identificación',
        size: 50,
        Cell: ({ row }) => (
          row.original?.prospecto_pymes_data?.identificacion
        ),
      },
      {
        accessorKey: 'cliente_razon_social',
        header: 'Cliente',
        size: 300,
        Cell: ({ row }) => (
          cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_pymes_data?.razon_social!)
        ),
      },
      {
        accessorKey: 'nombre_enlace',
        header: 'Nombre Enlace',
        size: 250,
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'Fecha de Preagenda',
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion'),
      },
      {
        accessorKey: 'fecha_modificacion',
        header: 'Fecha de Última Modificación',
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_modificacion'),
      },
      {
        accessorKey: 'fecha_instalacion',
        header: 'Fecha instalación',
        size: 180,
      },
      {
        accessorKey: 'hora_instalacion',
        header: 'Hora instalación',
        size: 180,
      },
      {
        accessorKey: 'provincia_nombre',
        header: 'Provincia',
        size: 200,
        Cell: ({ row }) => row.original?.provincia_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'ciudad_nombre',//ciudad_data.nombre
        header: 'Ciudad',
        size: 200,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || 'N/A',
      },
      /* {
        accessorKey: 'flota_nombre',
        header: 'FLOTA',
        size: 180,
        Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
      }, */
      /*  {
         accessorKey: 'coordenadas',
         header: 'COORDENADAS',
         size: 180,
 
         Cell: ({ row }) => emptyCellOneLevel(row, 'coordenadas'),
       }, */
      {
        accessorKey: 'celular',
        header: 'CELULAR CLIENTE',
        size: 180,
        Cell: ({ row }) => row.original?.prospecto_pymes_data?.celular || 'N/A',
      },
      {
        accessorKey: 'celular_2',
        header: 'CELULAR 2',
        size: 180,

        Cell: ({ row }) => row.original?.preventa_pymes_data?.celular_2 || 'N/A',
      },
      {
        accessorKey: 'estado_preagendamiento',
        header: 'estado pyl',
        size: 150,
        // enableColumnFilter: false,
        filterVariant: 'select',
        filterSelectOptions: ESTADO_PREAGENDAMIENTO_PYL,
        enableSorting: false,
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={
              calcColorStatePreAgenda(
                row.original?.estado_preagendamiento as EstadosPreagendamientoCodigoEnum)
            }
            texto={
              calcStateTextPreAgenda(
                row.original?.estado_preagendamiento as EstadosPreagendamientoEnumChoice)
            }
          />
        ),
      },
      {
        accessorKey: 'fecha_aceptacion',
        header: 'fecha de aceptación',
        size: 300,
        Cell: ({ row }) => row.original?.preventa_pymes_data?.fecha_aceptacion !== null ? dayjs(row.original?.preventa_pymes_data?.fecha_aceptacion).format("L LT") : "N/A",
      },
      {
        accessorKey: 'direccion',
        header: 'direccion',
        size: 300,
        Cell: ({ row }) => row.original?.preventa_pymes_data?.direccion || 'N/A',
      },
      /* {
        accessorKey: 'nap',
        header: 'NAP',
        size: 180,
        Cell: ({ row }) => row.original?.nap_data.nombre || 'N/A',
      }, */
      {
        accessorKey: 'distancia',
        header: 'DISTANCIA A LA NAP',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
      },
      {
        accessorKey: 'contrato_numero',
        header: 'Núm. Contrato',
        size: 240,
        Cell: ({ row }) =>
          row.original?.contrato_data?.numero_referencia || 'N/A',
      },
      {
        accessorKey: 'contrato_tipo_plan',
        header: 'Tipo Plan',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_pymes_data?.tipo_plan || 'N/A';
        },
      },
      /* {
        accessorKey: 'plan',
        header: 'Plan de internet',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || 'N/A';
        },
      }, */
      {
        accessorKey: 'tipo_servicio',
        header: 'Tipo de servicio',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_pymes_data?.tipo_servicio || 'N/A';
        },
      },
{
        accessorKey: 'user_gestionando',
        header: 'Gestión',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.user_gestionando || 'N/A';
        },
      },
    ],
    []
  );

  return {
    preagendamientoColumns
  }
}